export const lastPageChartConfig = {
  chart: {
    height: 220
  }
};
